export const firebaseConfig = {
    apiKey: "AIzaSyBFxwhn3rq200-MXwkDrLTdWO0yAQU57pQ",
    authDomain: "accon-demo-frontend.firebaseapp.com",
    databaseURL: 'https://accon-demo-frontend-default-rtdb.firebaseio.com/',
    projectId: "accon-demo-frontend",
    storageBucket: "accon-demo-frontend.appspot.com",
    messagingSenderId: "1098922948287"

  };